import { render, staticRenderFns } from "./WorkoutRecorded.vue?vue&type=template&id=566fa092"
import script from "./WorkoutRecorded.vue?vue&type=script&lang=js"
export * from "./WorkoutRecorded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports